import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';
import card from '../../../../assets/images/bg/card.png';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: 0,
      overflow: 'visible',
      [theme.breakpoints.down(Sizes.mobile)]: {
        display: 'block',
      },
    },
    backContainer: {
      display: 'flex',
      cursor: 'pointer',
      fontSize: 14,
      fontWeight: 600,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 20,
      },
    },
    backChevron: {
      fontSize: 18,
      fontWeight: 600,
      marginRight: 8,
      color: colorVariables.navy,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 20,
        marginTop: 5,
      },
    },
    subHeader1: {
      marginBottom: 10,
      color: colorVariables.userNavy,
      textAlign: 'center',
      fontSize: 32,
      fontWeight: 700,
    },
    subHeader2: {
      fontSize: 16,
      fontWeight: 600,
      color: colorVariables.grey60,
      textAlign: 'center',
      marginBottom: 10,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 14,
        fontWeight: 400,
        marginTop: 14,
      },
    },
    billedSwitch: {
      textAlign: 'center',
      marginBottom: 20,
    },
    billedMonthly: {
      fontSize: 14,
      fontWeight: 400,
      color: colorVariables.grey60,
    },
    billedAnnually: {
      fontSize: 14,
      fontWeight: 400,
      color: colorVariables.grey60,
    },
    billedActive: {
      fontWeight: 700,
      color: colorVariables.navy,
    },
    save20: {
      color: '#40C369',
    },
    card: {
      borderRadius: 20,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid rgba(0,0,0,0.1)',
    },
    cardContent: {
      padding: '0 !important',
    },
    bodyContainer: {
      textAlign: 'center',
      padding: 24,
      width: '75%',
      margin: '0 auto',
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
      },
    },
    cardFeatureTitle: {
      fontWeight: 700,
      fontSize: 24,
      marginBottom: theme.spacing(1),
      color: colorVariables.navy,
      textTransform: 'capitalize',
    },
    summaryRow: {
      display: 'flex',
      justifyContent: 'space-between',
      fontWeight: 700,
      fontSize: 16,
    },
    summarySubRow: {
      fontWeight: 400,
      fontSize: 14,
      textAlign: 'right',
    },
    includesTitle: {
      borderBottom: `1px solid ${colorVariables.steelGrey}`,
      marginTop: 10,
    },
    track: {
      backgroundColor: colorVariables.steelGrey,
      opacity: 1,
    },
    thumb: {
      backgroundColor: colorVariables.white,
      width: 20,
      height: 20,
    },
    checked: {
      '&.MuiSwitch-switchBase + .MuiSwitch-track': {
        backgroundColor: '#44B5E6',
        opacity: 1,
      },
    },
    checkIcon: {
      color: '#40C369',
      marginRight: theme.spacing(1),
    },
    closeIcon: {
      color: '#FA6767',
      marginRight: theme.spacing(1),
    },
    active: {
      border: `1px solid ${colorVariables.blue}`,
    },
    listItemIcon: {
      minWidth: 'auto',
    },
    listItemWrapper: {
      padding: '5px 0',
    },
    listItemText: {
      margin: 0,
    },
    paymentContainer: {
      margin: '0 50px 50px 50px',
      border: '1px solid rgba(0,0,0,0.1)',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      borderRadius: 20,
      backgroundColor: '#F6F8FD',
      padding: 20,
      backgroundImage: `url(${card})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top 10px right 10px',
      backgroundSize: '46px auto',
      [theme.breakpoints.down(Sizes.mobile)]: {
        margin: 4,
        marginBottom: 80,
      },
    },
    paymentServices: {
      minHeight: 52,
      justifyContent: 'center',
      width: '30%',
      margin: '0 auto',
    },
    orText: {
      textAlign: 'center',
      fontWeight: 400,
      fontSize: 14,
      margin: '10px 0',
    },
    formBoxWrap: {
      width: '100%',
      marginRight: 23,
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
        marginRight: 0,
      },
    },
    modalBox: {
      padding: 0,
      textAlign: 'center',
      width: '35%',
      height: 'auto',
      overflow: 'hidden',
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '95%',
      },
    }
  }),
);
